<template>
  <v-col>
    <div class="invoice-box">
      <!-- <div> -->
      <table cellpadding="0" cellspacing="0">
        <tr class="top">
          <td colspan="4">
            <table>
              <tr>
                <td class="title">
                  <img
                    src="@/assets/deeppath.png"
                    style="width:100%; max-width:300px;"
                  />
                  <h1>{{ $t('report.reportForm.reportTitle') }}</h1>
                </td>
                <td>
                  Report # 123<br />
                  Created: {{ date }}<br />
                  {{ scanner.manufacturer }}<br />
                  {{ scanner.model }}<br />
                  {{ scanner.serial }}
                </td>
              </tr>
            </table>
          </td>
        </tr>

        <tr class="information">
          <td colspan="4">
            <table>
              <tr>
                <td>
                  {{ organization }}<br />
                  1234 la calle<br />
                  Santiago, Santiago 12345
                </td>
                <td>
                  Departamento Patología<br />
                  Dr. patologo, el<br />
                  patologo@patologia.pl
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <v-spacer></v-spacer>
        <v-row>
          <v-col class="mt-2">
            <v-data-table
              :v-if="diagnosisByName !== undefined"
              :headers="probHeaders"
              :items="probItems"
              item-key="name"
              sort-by="prob"
              :sort-desc="true"
              hide-default-footer
              flat
              dense
            >
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ $t('report.' + item.name) }}</td>
                <td>{{ item.prob.toFixed(2) }} %</td>
                <td>{{ item.sus_area.toFixed(2) }} mm<sup>2</sup></td>
                <td>{{ item.sus_percentage.toFixed(2) }} %</td>
                <td>{{ item.sus_count }}</td>
              </tr>
            </template>
              <template v-slot:item.prob="{ item }">
                {{ item.prob + " %" }}
              </template>
              <template v-slot:item.sus_percentage="{ item }">
                {{ item.sus_percentage + " %" }}
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-textarea
          outlined
          name="additionTest"
          label="Información adicional"
          auto-grow
          class="mt-4"
        >
        </v-textarea>
      </table>
      <!-- <Print></Print> -->
    </div>
    <div class="d-flex">
      <v-col
        offset="4"
        cols="4"
      >
        <v-tooltip right>
          <template v-slot:activator="{ on, attr }">
            <v-btn
              block
              tile
              elevation="0"
              v-on="on"
              v-bind="attr"
              @click="goBackEdit"
            >
              <v-icon
                left
                light
              >
                mdi-arrow-left-thick
              </v-icon>
              {{ $t("report.reportForm.goBackReportButton") }}
            </v-btn>
          </template>
          <span>
            {{ $t("report.reportForm.goBackReportButtonTooltip") }}
          </span>
        </v-tooltip>
        <v-tooltip right>
          <template v-slot:activator="{ on, attr }">
            <v-btn
              block
              tile
              class="warning"
              elevation="0"
              v-on="on"
              v-bind="attr"
              @click="goBack"
            >
              {{ $t("report.reportForm.goBackListButton") }}
            </v-btn>
          </template>
          <span>
              {{ $t("report.reportForm.goBackListButtonTooltip") }}
          </span>
        </v-tooltip>
        <v-tooltip right>
          <template v-slot:activator="{ on, attr }">
            <v-btn
              block
              tile
              class="info"
              elevation="0"
              v-on="on"
              v-bind="attr"
            >
              <v-icon
                left
                light
              >
                mdi-clipboard-file
              </v-icon>
              {{ $t("report.reportForm.printButton") }}
            </v-btn>
          </template>
          <span>
            {{ $t("report.reportForm.printButtonTooltip") }}
          </span>
        </v-tooltip>
      </v-col>
    </div>
  </v-col>
</template>
<script>
import { mapState } from "vuex";
import {
  LOAD_DIAGNOSIS,
} from "@/store/modules/diagnosis";
import {
  CURRENT_REPORTWSI,
  ACTION_SET_CURRENT_REPORTDIAGNOSIS,
  ACTION_SET_CURRENT_REPORTWSI,
  ACTION_SET_CURRENT_REPORTTILEGRID,
} from "@/store/modules/service";
// import Print from "@/components/service/Print";

export default {
  data() {
    return {
      organization: "Hospital Clínico Universidad de Chile",
      scanner: {
        serial: "4321-12asdf",
        model: "S360",
        manufacturer: "Hamamatsu"
      },
      date: "2021-09-28",
      areas: [],
      probItems: [],
      areaByDiagnosis: {},
    };
  },
  computed: {
    ...mapState({
      reportWSI: state => state.service.currentReportWSI,
      reportTileGrid: state => state.service.currentReportTileGrid,
      reportDiagnosis: state => state.service.currentReportDiagnosis,
      diagnosisByName: state => state.diagnosis.byName
    }),
    probHeaders() {
      return [
        { text: this.$t("report.diagnosisTable.class"), value: "name", align: "start"},
        { text: this.$t("report.diagnosisTable.confidenceLevel"), value: "prob"},
        { text: this.$t("report.diagnosisTable.areaSize"), value: "sus_area"},
        { text: this.$t("report.diagnosisTable.areaPercentage"), value: "sus_percentage"},
        { text: this.$t("report.diagnosisTable.areaCount"), value: "sus_count"},
      ];
    },
  },
  methods: {
    goBack() {
      this.$router.push({ name: "service" })
    },
    goBackEdit() {
      const id =  this.$store.getters[CURRENT_REPORTWSI].id
      this.$store.dispatch(LOAD_DIAGNOSIS);
      this.$store.dispatch(ACTION_SET_CURRENT_REPORTWSI, { id });
      this.$store.dispatch(ACTION_SET_CURRENT_REPORTTILEGRID, { id });
      this.$store.dispatch(ACTION_SET_CURRENT_REPORTDIAGNOSIS, { id });
      this.$router.push({
        name: "service-view",
        params: { id: id }
      });
    },
    setDiagnosis() {
      this.probItems = [];
      const diagnosis_dict = {};
      Object.values(this.diagnosisByName).forEach(diagnosis => {
        diagnosis_dict[diagnosis.id] = diagnosis.name;
      });
      this.reportDiagnosis.forEach(prob => {
        const count = this.diagnosisByName[diagnosis_dict[prob.label]].count;
        const ratio = this.diagnosisByName[diagnosis_dict[prob.label]].ratio;
        const color = this.diagnosisByName[diagnosis_dict[prob.label]].color;
        const area = this.areaByDiagnosis[diagnosis_dict[prob.label]]
          ? this.areaByDiagnosis[diagnosis_dict[prob.label]]
          : 0;
        this.probItems.push({
          name: diagnosis_dict[prob.label],
          prob: prob.confidence_level * 100,
          color: color,
          sus_count: count,
          sus_percentage: ratio,
          sus_area: area,
        });
      });
    },
    setAreas() {
      this.areas = [];
      this.areaByDiagnosis = {};
      Object.keys(this.reportTileGrid.tilegrid_json["areas"]).forEach(areas => {
        areas = this.reportTileGrid.tilegrid_json["areas"][areas];
        Object.keys(areas).forEach(area => {
          area = areas[area];
          let classType = area["class"].toLowerCase();
          if (classType === "otro") classType = "other"; //FIX LOCALIZATION FROM CDSS
          const classDef = this.diagnosisByName[classType];
          const size = area["area"];
          const ratio = area["rate"];
          const suspicious = area["suspicious"];
          const id = area["id"];
          const label = area["label"] ? area["label"] : id;
          if (suspicious) {
            this.areas.push({
              id: id,
              class: classDef.name,
              area: size,
              percentage: ratio,
              suspicious: suspicious,
              validated: false,
              color: classDef.color,
              label: label
            });
            this.areaByDiagnosis[classDef.name] =
              (this.areaByDiagnosis[classDef.name] || 0) + size;
          }
        });
      });
    }
  },
  mounted() {
    this.setAreas();
    this.setDiagnosis();
  }
  // components: {
  //   Print
  // }
};
</script>
<style scoped>
.opacity-6 {
  color: rgba(0, 0, 0, 0.6);
}
.invoice-box {
  /* max-width: 100%; */
  max-width: 874px;
  margin: auto;
  padding: 30px;
  border: 1px solid #eee;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  font-size: 16px;
  line-height: 24px;
  font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
  color: #555;
}

.invoice-box table {
  width: 100%;
  line-height: inherit;
  text-align: left;
}

.invoice-box table td {
  padding: 5px;
  vertical-align: top;
}

.invoice-box table tr td:nth-child(n + 2) {
  text-align: right;
}

.invoice-box table tr.top table td {
  padding-bottom: 20px;
}

.invoice-box table tr.top table td.title {
  font-size: 45px;
  line-height: 45px;
  color: #333;
}

.invoice-box table tr.information table td {
  padding-bottom: 40px;
}

.invoice-box table tr.heading td {
  background: #eee;
  border-bottom: 1px solid #ddd;
  font-weight: bold;
}

.invoice-box table tr.details td {
  padding-bottom: 20px;
}

.invoice-box table tr.item td {
  border-bottom: 1px solid #eee;
}

.invoice-box table tr.item.last td {
  border-bottom: none;
}

.invoice-box table tr.item input {
  padding-left: 5px;
}

.invoice-box table tr.item td:first-child input {
  margin-left: -5px;
  width: 100%;
}

.invoice-box table tr.total td:nth-child(2) {
  border-top: 2px solid #eee;
  font-weight: bold;
}

.invoice-box input[type="number"] {
  width: 60px;
}

@media only screen and (max-width: 600px) {
  .invoice-box table tr.top table td {
    width: 100%;
    display: block;
    text-align: center;
  }

  .invoice-box table tr.information table td {
    width: 100%;
    display: block;
    text-align: center;
  }
}

/** RTL **/
.rtl {
  direction: rtl;
  font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
    sans-serif;
}

.rtl table {
  text-align: right;
}

.rtl table tr td:nth-child(2) {
  text-align: left;
}
</style>
